import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  pending: false,
  list: []
});

export function setList(state, list) {
  return state.merge({ list });
}

export function setPendingSelf(state, pending = true) {
  return state.set('pending', !!pending);
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'KITS_PENDING':
      return setPendingSelf(state, action.pending);

    case 'KITS_LIST':
      return setList(state, action.list);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/kits.js